import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function ContactBanner() {

  const [ContactBanner, setContactBanner] = useState([]);

  useEffect(() => {
    const fetchContactBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/contact/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setContactBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchContactBanner();
  }, []);

  return (
    <div className='common-banner-sec common-flex-center contact-banner'
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + ContactBanner.banner_image
          })`,
      }}
    >
      <div className='overlay'></div>
      <Container fluid>
        <Row className='common-flex-center'>
          <Col md={8}>
            <div className=' '>
              <h1 className='common-head whiteColor'>{ContactBanner.banner_title}</h1>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ContactBanner;